import { IconButton, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Tooltip, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import {
  EmployeeByDepartmentQueryType,
  QUERY_TYPE_VISUAL,
} from '../../query-type';
import * as SX from './sx';
import type { EmployeeByDepartmentItemQuerySectionProps as Props } from './types';

const QUERY_TYPE_ORDER: EmployeeByDepartmentQueryType[] = [
  EmployeeByDepartmentQueryType.INCLUDE,
  EmployeeByDepartmentQueryType.EXCLUDE,
  EmployeeByDepartmentQueryType.INCLUDE_AND,
];

export const EmployeeByDepartmentItemQuerySection = memo(
  ({ className, queryType, onChange }: Props) => {
    const selectedVisual = QUERY_TYPE_VISUAL[queryType];

    const handleClick = useCallback(
      (next: EmployeeByDepartmentQueryType) => () => onChange(next),
      [onChange]
    );

    return (
      <Box
        className={classnames(
          'EmployeeByDepartmentItemQuerySection',
          className
        )}
        sx={SX.root}
      >
        <Divider />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pt={1}
        >
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography variant="body4" color="grey.500">
              Settings:
            </Typography>
            <Label color={selectedVisual.color} variant="soft" size="xxxsmall">
              {selectedVisual.labelText}
            </Label>
          </Box>
          <Box display="flex" gap={0.5}>
            {QUERY_TYPE_ORDER.map((qt) => {
              const visual = QUERY_TYPE_VISUAL[qt];
              const selected = queryType === qt;
              return (
                <Tooltip
                  key={qt}
                  title={visual.buttonLabel}
                  placement="top"
                  enterDelay={1000}
                  enterNextDelay={1000}
                >
                  <span>
                    <IconButton
                      size="xsmall"
                      variant="outlined"
                      iconColor={selected ? `${visual.color}.600` : 'grey.600'}
                      color={selected ? visual.color : 'default'}
                      iconSize={16}
                      icon={visual.icon}
                      onClick={handleClick(qt)}
                    />
                  </span>
                </Tooltip>
              );
            })}
          </Box>
        </Box>
      </Box>
    );
  }
);

EmployeeByDepartmentItemQuerySection.displayName =
  'EmployeeByDepartmentItemQuerySection';
